import React from 'react';
import { AppendEdge, MergeEdge } from './components/Edges';
import { Chip } from '@mui/material';
import { TimelapseTwoTone, EmailTwoTone, ErrorTwoTone, CheckCircleTwoTone, CallMergeTwoTone, FilterAltTwoTone, SmsTwoTone, CallSplitRounded, LoginTwoTone, LogoutTwoTone } from '@mui/icons-material';
import MessageEmailEditNode from './components/Nodes/Edit/MessageEmailEditNode';
import OutputEditNode from './components/Nodes/Edit/OutputEditNode';
import EnterEditNode from './components/Nodes/Edit/EnterEditNode';
import BranchFilterEditNode from './components/Nodes/Edit/BranchFilterEditNode';
import WaitEditNode from './components/Nodes/Edit/WaitEditNode';
import SpigotEditNode from './components/Nodes/Edit/SpigotEditNode';
import MergeEditNode from './components/Nodes/Edit/MergeEditNode';

// Centralized icon component for step types
export const StepTypeIcon = ({ step, fontSize = 'small', color, style = {}, ...props }) => {
    const getIconForStepType = (type) => {
        const baseStyle = { transform: 'rotate(180deg)' };
        const combinedStyle = { ...baseStyle, ...style };
        
        console.log('StepTypeIcon called with type:', type, 'step:', step);
        
        switch(type) {
            case 'email':
                return <EmailTwoTone fontSize={fontSize} color={color} style={style} {...props} />;
            case 'sms':
                return <SmsTwoTone fontSize={fontSize} color={color} style={style} {...props} />;
            case 'wait':
                return <TimelapseTwoTone fontSize={fontSize} color={color} style={style} {...props} />;
            case 'branch_filter':
                return <CallSplitRounded fontSize={fontSize} color={color} style={combinedStyle} {...props} />;
            case 'spigot':
                return <FilterAltTwoTone fontSize={fontSize} color={color} style={style} {...props} />;
            case 'merge':
                return <CallMergeTwoTone fontSize={fontSize} color={color} style={combinedStyle} {...props} />;
            case 'enter':
                console.log('Returning LoginTwoTone for enter');
                return <LoginTwoTone fontSize={fontSize} color={color} style={style} {...props} />;
            case 'exit':
                console.log('Returning LogoutTwoTone for exit');
                return <LogoutTwoTone fontSize={fontSize} color={color} style={style} {...props} />;
            default:
                console.log('No icon found for type:', type);
                return null;
        }
    };

    return getIconForStepType(step?.type);
};

export const layoutOptions = {
    'elk.layered.directionCongruency': 'READING_DIRECTION',
    'elk.partitioning.activate': true,
    'elk.hierarchyHandling': 'SEPARATE_CHILDREN',
    'elk.layered.nodePlacement.strategy': 'NETWORK_SIMPLEX',
    'elk.layered.nodePlacement.bk.edgeStraightening': 'IMPROVE_STRAIGHTNESS',
    'elk.layered.nodePlacement.favorStraightEdges': true,
    // 'elk.layered.compaction.postCompaction.strategy': 'EDGE_LENGTH',
    // 'elk.layered.nodePlacement.networkSimplex.nodeFlexibility.default': 'NODE_SIZE_WHERE_SPACE_PERMITS',
    'elk.layered.nodePlacement.bk.fixedAlignment': 'BALANCED',
    // Spacing
    // 'elk.spacing.nodeNode': 0,
    'elk.layered.spacing.nodeNodeBetweenLayers': 30,
    //'elk.spacing.componentComponent': 60,
    // 'elk.spacing': 110,
    // 'elk.spacing.individual': 150,
    'elk.spacing.edgeNode': 0,
    'elk.spacing.portPort': 0,

    'elk.layered.spacing.edgeEdge': 0,
    'elk.layered.spacing.edgeEdgeBetweenLayers': 0,

    //Edges
    // 'elk.layered.considerModelOrder.longEdgeStrategy': 'DUMMY_NODE_UNDER',

    // Debugging
    'elk.debugMode': true,

    'elk.zoomToFit': true,
    'elk.interactive': true,
    'elk.interactiveLayout': true,
    'elk.omitNodeMicroLayout': true,
    'elk.mergeEdges': true
};

export const EDGE_TYPES = {
    draft: {
        append: AppendEdge,
        merged: MergeEdge
    },
    active: {
        append: MergeEdge,
        merged: MergeEdge
    }
};

// Helper function to create icon for node groups
const createNodeGroupIcon = (type) => {
    const mockStep = { type };
    return <StepTypeIcon step={mockStep} color={undefined} />;
};

export const NODE_GROUPS = [
    {
        label: 'Email',
        icon: createNodeGroupIcon('email'),
        type: 'email'
    },
    // {
    //     label: 'SMS',
    //     icon: createNodeGroupIcon('sms'),
    //     type: 'sms'
    // },
    {
        label: 'Split',
        icon: createNodeGroupIcon('branch_filter'),
        type: 'branch_filter'
    },
    {
        label: 'Wait',
        icon: createNodeGroupIcon('wait'),
        type: 'wait'
    },
    {
        label: 'Merge',
        icon: createNodeGroupIcon('merge'),
        type: 'merge'
    },
    {
        label: 'Spigot',
        icon: createNodeGroupIcon('spigot'),
        type: 'spigot'
    } 
];

export const EDIT_NODE_TYPES = {
    enter: EnterEditNode,
    branch_filter: BranchFilterEditNode,
    wait: WaitEditNode,
    exit: OutputEditNode,
    email: MessageEmailEditNode,
    spigot: SpigotEditNode,
    // sms: SMSNode,
    merge: MergeEditNode
};

export const NODE_SIDEBARS = [
    'branch_filter',
    'wait',
    'email',
    'sms',
    'spigot'
];

export const NODE_HIDDEN = [
    'enter',
    'exit'
];

export const STEP_TYPES = Object.entries(EDIT_NODE_TYPES).map(([type, node]) => type);

// specifies the edge type based on the StepFrom type
export const NODE_EDGE = {
    enter: 'append',
    wait: 'append',
    branch_filter: 'append',
    wait_internal: 'regular',
    sms: 'append',
    email: 'append',
    merge: 'append', 
    exit: 'append',
    spigot: 'append'
};

export const NODE_WIDTH = 250;
export const NODE_HEIGHT = 70;


export const NODE_EXTENT = [
    [0,0],
    [2500, 2500]
];

export const flowStates = {
    'edited': <Chip size='small' label='Edited' color='secondary' className='flow-header__status secondary' style={{fontSize: 12, padding: '0px !importantx', fontWeight: 400}}/>,
    'draft': <Chip size='small' label='Draft' color='secondary' className='flow-header__status default' style={{fontSize: 12, padding: '0px !importantx', fontWeight: 400}}/>,
    'active': <Chip size='small' label='Active' color='primary' className='flow-header__status primary' style={{fontSize: 12, padding: '0px !importantx', fontWeight: 400}}/>
};

export const flowStateChip = (status, isChanged, size = 'small') => {
    let fontSize = 14;
    if(size === 'small') {
        fontSize = 10;
    } else if(size === 'normal') {
        fontSize = 18;
    }

    const states = {
        'edited': <Chip size={size} label='Edited' color='secondary' className='flow-header__status secondary' style={{fontSize: fontSize, padding: '0px !importantx', fontWeight: 400}}/>,
        'draft': <Chip size={size} label='Draft' color='secondary' className='flow-header__status default' style={{fontSize: fontSize, padding: '0px !importantx', fontWeight: 400}}/>,
        'active': <Chip size={size} label='Active' color='primary' className='flow-header__status primary' style={{fontSize: fontSize, padding: '0px !importantx', fontWeight: 400}}/>
    };

    let state = status;

    if(status === 'active' && isChanged) {
        state = 'edited';
    }

    return states[state];
};

export const flowSendStates = {
    false: <ErrorTwoTone color='warning' style={{fontSize: 19}} />,
    true: <CheckCircleTwoTone color='success' style={{fontSize: 19}} />
};

export const FLOWS_TABLE_HEADERS =  [
    {
        id: 'i',
        numeric: true,
        disablePadding: true,
        label: ''
    },
    {
        id: 'name',
        numeric: false,
        disablePadding: false,
        label: 'Name'
    },
    {
        id: 'label',
        numeric: false,
        disablePadding: false,
        label: 'Label'
    },
    {
        id: 'description',
        numeric: false,
        disablePadding: false,
        label: 'Description'
    }
];

// export const MESSAGE_STEPS = [
//     'headers', 'content', 'send-preview'
// ];

export const SMS_MESSAGE_STEPS = [
    'message', 'send-preview'
];

export const ISSUE_SECTIONS = {
    'filter': 'Branch',
    'allocations': 'Message',
    'wait': 'Wait'
};
